import { useEffect } from 'react';
import { isMobile } from '@/utils';
import ExceptionPage from '@/components/ExceptionPage';

const Custom404 = () => {

  useEffect(() => {
    const errorObj: any = new Error('BlankScreen');
    errorObj.name = 'page 404';
    window.Sentry?.captureException(errorObj);
  }, []);

  return (
    <ExceptionPage
      title="您所访问的页面不存在"
      isMobile={isMobile}
      onReturn={() => {
        window.location.href = '/';
      }}
      buttonText="返回"
    />
  );
};

export default Custom404;
